import { useNavigate } from "react-router";
import type { NotificationItem } from "@omts/shared";
import { useAuth } from "../auth";
import { NotificationRow, useNotifications } from "../components/NotificationBell";

/** Все уведомления пользователя (раздел 15.1): последние 200, клик — в карточку заявки. */
export function NotificationsPage() {
  const { data, error, markRead, markAllRead } = useNotifications(200);
  const { user } = useAuth();
  const navigate = useNavigate();
  const unread = data?.unreadCount ?? 0;

  const open = (n: NotificationItem) => {
    void markRead(n);
    if (n.lotId) navigate(`/lots/${n.lotId}`);
  };

  return (
    <>
      <div className="page-header">
        <h1>
          Уведомления {unread > 0 && <span className="badge danger">{unread} новых</span>}
        </h1>
        <button type="button" className="btn" disabled={unread === 0} onClick={() => void markAllRead()}>
          Отметить все прочитанными
        </button>
      </div>
      {!user?.telegramLinked && (
        <p className="notice warn">Telegram не подключён — уведомления приходят только сюда. Подключить бота можно во вкладке «Профиль».</p>
      )}
      {error && <p className="error">{error}</p>}
      <section className="card notif-page" style={{ padding: 0 }}>
        {!data ? (
          <p className="notif-empty">Загрузка…</p>
        ) : data.items.length === 0 ? (
          <p className="notif-empty">Уведомлений пока нет. Сюда приходят новые заявки, ставки, итоги торгов, доставка и сообщения перевозчиков.</p>
        ) : (
          <ul className="notif-list" style={{ maxHeight: "none" }}>
            {data.items.map((n) => (
              <li key={n.id}>
                <NotificationRow n={n} onOpen={open} />
              </li>
            ))}
          </ul>
        )}
      </section>
    </>
  );
}
